import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Text } from '@components/Restyle';
import Button from '@components/shared/Button/Button';
import Icon from '@components/shared/Icon/Icon';
import { ActivityRowSkeleton } from '@components/shared/skeletons';
import theme from '@themes/theme';

interface ActivityPaywallFooterProps {
  onUpgrade: () => void;
  buttonLabel: string;
}

export const ActivityPaywallFooter: React.FC<ActivityPaywallFooterProps> = ({
  onUpgrade,
  buttonLabel,
}) => {
  const { t } = useTranslation('models');

  return (
    <Box paddingHorizontal='m'>
      {/* Dashed separator */}
      <Box
        borderTopWidth={2}
        borderTopColor='grey02'
        style={{ borderStyle: 'dashed' }}
      />

      {/* Green upgrade banner */}
      <Box
        marginTop='m'
        marginBottom='xs'
        borderRadius='m'
        padding='m'
        backgroundColor='greenSecondaryMild'
        borderWidth={1}
        borderColor='greenSecondary'>
        <Box
          flexDirection='row'
          alignItems='center'
          style={{ gap: theme.spacing.s }}>
          <Icon name='ZapFilled' variant='l' color='greenSecondary' />
          <Box flex={1}>
            <Text
              variant='labelEmphasized'
              color='textPrimary'
              marginBottom='xxs'>
              {t('activity.paywallFooterTitle')}
            </Text>
            <Text variant='labelSmall' color='textSecondary'>
              {t('activity.paywallFooterDescriptionPrefix') + ' '}
              <Text variant='labelEmphasized14' color='textSecondary'>
                {buttonLabel}
              </Text>
              {' ' + t('activity.paywallFooterDescriptionSuffix')}
            </Text>
          </Box>
          <Button
            onPress={onUpgrade}
            accessibilityLabel={buttonLabel}
            isSmall
            backgroundColor='black'
            btnTextColor='white'
            height={36}>
            {buttonLabel}
          </Button>
        </Box>
      </Box>

      {/* Skeleton row */}
      <ActivityRowSkeleton />

      <Box mb='l' />
    </Box>
  );
};
